export const CONSTANTS = {
	PAGE_SIZE_ALL: 2500,
	PAGE_DOBLE_BIG_SIZE: 100,
	PAGE_BIG_SIZE: 50,
	PAGE_LARGE_SIZE: 30,
	PAGE_MEDIUM_SIZE: 20,
	PAGE_SMALL_SIZE: 11,
	DISTRIBUTORS_COLUMNS: [
		{ value: "OrderNumMobile", label: "N TRF Checkpos" },
		{ value: "Name", label: "Nombre Pdv" },
		{ value: "BusinessName", label: "Razon Social" },
		{ value: "Cuit", label: "Cuit" },
		{ value: "PostalCode", label: "Cod. Postal" },
		{ value: "Address", label: "Direccion Pdv" },
		{ value: "DistributorCode", label: "Cod. Drogueria" },
		{ value: "Created", label: "Fecha" },
		{ value: "ProductEan13", label: "Ean" },
		{ value: "ProductTitle", label: "Descripcion" },
		{ value: "ProductPresentation", label: "Presentacion" },
		{ value: "Quantity", label: "Cantidad" },
		{ value: "OfferPrice", label: "Desc. Total" },
		{ value: "GeneralDiscount", label: "Desc. Base" },
		{ value: "Discount", label: "Desc. Oferta" },
		{ value: "TriggerDiscount", label: "Desc. Cantidad" },
		{ value: "CampaignDiscount", label: "Desc. Campaña" },
		{ value: "ProvinceName", label: "Provincia" },
		{ value: "LocalityName", label: "Localidad" },
		{ value: "PaymentTermCode", label: "Plazo Codigo" },
		{ value: "PaymentTermName", label: "Plazo Nombre" },
		{ value: "PaymentTermDescription", label: "Plazo Descripcion" },
		{ value: "PaymentTermDays", label: "Plazo Dias Facturacion" },
		{ value: "Empty1", label: "Vacia 1" },
		{ value: "Empty2", label: "Vacia 2" },
		{ value: "Empty3", label: "Vacia 3" },
		{ value: "Empty4", label: "Vacia 4" },
		{ value: "Empty5", label: "Vacia 5" },
		{ value: "Empty6", label: "Vacia 6" },
		{ value: "Empty7", label: "Vacia 7" },
		{ value: "Empty8", label: "Vacia 8" },
		{ value: "Empty9", label: "Vacia 9" },
		{ value: "Empty10", label: "Vacia 10" },
	],
	MEGA_DISTRIBUTORS_COLUMNS: [
		{ value: "OrderNumMobile", label: "N TRF Checkpos" },
		{ value: "Name", label: "Nombre Pdv" },
		{ value: "BusinessName", label: "Razon Social" },
		{ value: "Cuit", label: "Cuit" },
		{ value: "PostalCode", label: "Cod. Postal" },
		{ value: "Address", label: "Direccion Pdv" },
		{ value: "DistributorCode", label: "Cod. Cliente Drogueria" },
		{ value: "Created", label: "Fecha" },
		{ value: "ProductEan13", label: "Ean" },
		{ value: "ProductTitle", label: "Descripcion" },
		{ value: "ProductPresentation", label: "Presentacion" },
		{ value: "Quantity", label: "Cantidad" },
		{ value: "OfferPrice", label: "Desc. Total" },
		{ value: "GeneralDiscount", label: "Desc. Base" },
		{ value: "Discount", label: "Desc. Oferta" },
		{ value: "TriggerDiscount", label: "Desc. Cantidad" },
		{ value: "CampaignDiscount", label: "Desc. Campaña" },
		{ value: "DistributorName", label: "Drogueria" },
		{ value: "MegaDistributorCode", label: "Cod. Laboratorio" },
		{ value: "DistributorCuit", label: "Cuit Droguería" },
		{ value: "DistributorGln", label: "Gln Droguería" },
		{ value: "GlnAnmat", label: "Gln Pdv" },
		{ value: "PositionNumber", label: "N Posicion" },
		{ value: "ProvinceName", label: "Provincia" },
		{ value: "LocalityName", label: "Localidad" },
		{ value: "CommercialActionCode", label: "Cod. Accion Comercial" },
		{
			value: "MegaDistributorDistributorCode",
			label: "Cod. Distribuidor Drogueria",
		},
		{
			value: "MegaDistributorDistributorOfficeCode",
			label: "Cod. Sucursal Drogueria",
		},
		{ value: "ProductLaboratoryCode", label: "Cod. Producto Laboratorio" },
		{ value: "PaymentTermCode", label: "Plazo Codigo" },
		{ value: "PaymentTermName", label: "Plazo Nombre" },
		{ value: "PaymentTermDescription", label: "Plazo Descripcion" },
		{ value: "PaymentTermDays", label: "Plazo Dias Facturacion" },
		{ value: "Empty1", label: "Vacia 1" },
		{ value: "Empty2", label: "Vacia 2" },
		{ value: "Empty3", label: "Vacia 3" },
		{ value: "Empty4", label: "Vacia 4" },
		{ value: "Empty5", label: "Vacia 5" },
		{ value: "Empty6", label: "Vacia 6" },
		{ value: "Empty7", label: "Vacia 7" },
		{ value: "Empty8", label: "Vacia 8" },
		{ value: "Empty9", label: "Vacia 9" },
		{ value: "Empty10", label: "Vacia 10" },
	],
	TYPE_OF_FILE: ["csv", "xls", "txt"],
	TYPE_OF_SEND: ["email", "sftp", "ftp", "api"],
	MOBILE_BREAKPOINT_WIDTH_CHECK: 768,
	DISTRIBUTORS_FILTER_WITHOUTCONTRACT: "WITHOUTCONTRACT",
	DISTRIBUTORS_FILTER_WITHCONTRACT: "WITHCONTRACT",
	DISTRIBUTORS_FILTER_SUBMENU_ALL: "ALL",
	DISTRIBUTORS_FILTER_SUBMENU_INDIVIDUAL: "INDIVIDUAL",
	ONE_TRANSFER_CLIENT_ID: "2161aac9-7c52-42e3-a6a7-552bc2e410bf",
	GENERAL_POS_HISTORY_EXPORTED: "EXPORT",
	GENERAL_POS_HISTORY_CREATED: "CREATE",
	GENERAL_POS_HISTORY_UPDATED: "UPDATE",
	GENERAL_POS_HISTORY_DELETED: "DELETE",
	AFIP_STATUS_OK: "RESPONSABLE INSCRIPTO",
	CUIT_STRUCTURE_OK: "ESTRUCTURA VALIDA",
	CUIT_STRUCTURE_ERROR: "ESTRUCTURA INVALIDA",
	BIG_BANNER_HOME: "BIGBANNERHOME",
	TRIPLE_CARD_BANNER_HOME: "TRIPLECARDBANNERHOME",
	DOUBLE_BANNER_HOME: "DOUBLEBANNERHOME",
	TRIPLE_BANNER_HOME: "TRIPLEBANNERHOME",
	OFFER_BANNER: "OFFERBANNER",
	BOOK_UP_LEFT_BANNER: "UPLEFTBANNERBOOK",
	BOOK_DOWN_LEFT_BANNER: "DOWNLEFTBANNERBOOK",
	BOOK_UP_RIGHT_BANNER: "UPRIGHTBANNERBOOK",
	BOOK_DOWN_RIGHT_BANNER: "DOWNRIGHTBANNERBOOK",

	BIG_BANNER_HOME_HEIGHT: 420,
	BIG_BANNER_HOME_WIDTH: 1920,
	DOUBLE_BANNER_HOME_HEIGHT: 320,
	DOUBLE_BANNER_HOME_WIDTH: 680,
	TRIPLE_BANNER_HOME_HEIGHT: 160,
	TRIPLE_BANNER_HOME_WIDTH: 450,
	OFFER_BANNER_HEIGHT: 120,
	OFFER_BANNER_WIDTH: 1180,

	USER_ZONE_TYPE_ROUTE: "ROUTE",
	USER_ZONE_TYPE_REGION: "REGION",

	ORDER_STATE_PENDING: "Pending",
	ORDER_STATE_ACTIVE: "Active",
	ORDER_STATE_SENDED: "Sended",
	ORDER_STATE_CANCELED: "Canceled",
	ORDER_STATE_PROCESSED: "Processed",
	ORDER_STATE_BILLED: "Billed",
	ORDER_STATE_REJECTED: "Rejected",
	ORDER_STATE_RECEIVED: "Received",
	ORDER_STATE_PARTIAL_BILLED: "PartialBilled",

	ORDER_ITEM_STATE_BILLED: "FACTURADO",
	ORDER_ITEM_STATE_STOCK: "FALTA DE STOCK",
	ORDER_ITEM_STATE_WITHOUT_STOCK: "SIN STOCK",
	ORDER_ITEM_STATE_PROCESSED: "PROCESADO",
	ORDER_ITEM_STATE_UNEXIST: "INEXISTENTE",
	ORDER_ITEM_STATE_REJECTED: "RECHAZADO",
	ORDER_ITEM_STATE_RECEIVED: "RECIBIDO",
	ORDER_ITEM_STATE_ERROR: "ERROR",
	ORDER_ITEM_STATE_CANCELED: "CANCELADO",

	FILE_FOLDER_DISTRIBUTORS: "distributors",
	FILE_FOLDER_MEGADISTRIBUTORS: "megaDistributors",

	CLIENT_TYPE_ONETRANSFER: "ONETRANSFER",
	CLIENT_TYPE_PHARMACY: "PHARMACY",
	CLIENT_TYPE_LABORATORY: "LABORATORY",
	CLIENT_TYPE_LABORATORY_MOBILE: "LABORATORYMOBILE",
	CLIENT_TYPE_LABORATORY_MOBILE_AND_WEBSELLER: "LABORATORYMOBILEWEBSELLER",
	CLIENT_TYPE_LABORATORY_EXPO_AND_WEBSELLER: "LABORATORYEXPOWEBSELLER",
	CLIENT_TYPE_LABORATORY_EXPO: "LABORATORYEXPO",
	CLIENT_TYPE_LABORATORY_EXPO_AND_MOBILE: "LABORATORYEXPOANDMOBILE",
	CLIENT_TYPE_LABORATORY_WEBSELLER: "LABORATORYWEBSELLER",
	CLIENT_TYPE_LABORATORY_EXPO_AND_MOBILE_AND_WEBSELLER:
		"LABORATORYEXPOANDMOBILEANDWEBSELLER",

	ALL_VALUES: "ALL",

	BILLER_CONNECTIONS_TYPE: [
		{ value: "API", label: "API" },
		{ value: "FILE", label: "Importación de Archivo" },
	],

	CALENDAR_MONTHS: [
		"Empty",
		"Enero",
		"Febrero",
		"Marzo",
		"Abril",
		"Mayo",
		"Junio",
		"Julio",
		"Agosto",
		"Septiembre",
		"Octubre",
		"Noviembre",
		"Diciembre",
	],

	PERIOD_CURRENT: "CURRENT",
	PERIOD_HISTORICAL: "HISTORICAL",
	MOBILE_DASHBOARD_PERIODS: [
		{ value: "CURRENT", label: "Período actual" },
		{ value: "HISTORICAL", label: "Histórico" },
	],

	DASHBOARD_FILTERS: "DASHBOARDFILTERS",
	DASHBOARD_GENERAL: "GENERALDASHBOARD",
	DASHBOARD_SALES: "SALESDASHBOARD",
	DASHBOARD_MOBILE: "MOBILEDASHBOARD",
	DASHBOARD_PHARMACY: "PHARMACYDASHBOARD",
	DASHBOARD_REGION: "REGIONDASHBOARD",
	DASHBOARD_DISTRIBUTOR: "DISTRIBUTORDASHBOARD",
	DASHBOARD_LABORATORY: "DISTRIBUTORLABORATORY",
	DASHBOARD_CONVERSION: "CONVERSIONDASHBOARD",
	DASHBOARD_PRODUCTS: "PRODUCTSDASHBOARD",
	DASHBOARD_INITIATIVES: "INITIATIVESDASHBOARD",
	DASHBOARD_CHAIN: "CHAINDASHBOARD",

	CONTAINER_FILES: "files",
	CONTAINER_IMAGES: "images",
	CONTAINER_GUIDES: "guides",

	BOOK_LIST: "BOOKLIST",

	FEATURED_CATALOG: "FEATUREDCATALOG",
	FEATURED_HOME: "FEATUREDHOME",
	FEATURED_PRODUCTS: "FEATUREDPRODUCTS",
	FEATURED_STORES: "FEATUREDSTORES",
	FEATURED_LABORATORIES: "FEATUREDLABORATORIES",
	FEATURED_OFFERS: "FEATUREDOFFERS",

	DISTRIBUTOR_GLOBAL_FARM: "8b0a2eee-2720-40d7-a781-014592664485",

	PRODUCTS_ORIGIN_EXPO_EVENT: "EXPOEVENT",
	PRODUCTS_ORIGIN_WEB_SELLER: "WEBSELLER",
	PRODUCTS_ORIGIN_MOBILE: "MOBILE",

	COUPON_TYPES: [
		{ value: "GENERAL", label: "General" },
		{ value: "TRIGGER", label: "Por disparador" },
		{ value: "MULTILAB", label: "Multi laboratorio" },
	],

	MOBILE_CONFIG_APP_LOGO: "APPLOGOFILE",
	MOBILE_CONFIG_POS_IMAGE: "POSFILE",
	MOBILE_CONFIG_OFFER_IMAGE: "OFFERFILE",
	MOBILE_CONFIG_CART_IMAGE: "CARTFILE",
	MOBILE_CONFIG_ORDER_IMAGE: "ORDERFILE",

	DISTRIBUTOR_TYPE_DISTRIBUTOR: "DISTRIBUTOR",
	DISTRIBUTOR_TYPE_LABORATORY: "LABORATORY",

	USERS_WEB: "WEBUSERS",
	USERS_MOBILE: "MOBILEUSERS",

	SELECTOR_PRODUCT: "PRODUCT",
	SELECTOR_BRAND: "BRAND",

	ERP_MODULE_ORDERS: "ERPMODULEORDERS",
	ERP_MODULE_PHARMACIES: "ERPMODULEPHARMACIES",
	ERP_MODULE_USERS: "ERPMODULEUSERS",
	ERP_MODULE_STATES: "ERPMODULESTATES",
	ERP_MODULE_ERRORS: "ERPMODULEERRORS",

	ERP_MODULE_ORDERS_STEP_1: "ERPMODULEORDERSTEP1",
	ERP_MODULE_ORDERS_STEP_2: "ERPMODULEORDERSTEP2",
	ERP_MODULE_ORDERS_STEP_3: "ERPMODULEORDERSTEP3",
	ERP_MODULE_ORDERS_STEP_4: "ERPMODULEORDERSTEP4",

	ERP_MODULE_PHARMACIES_STEP_1: "ERPMODULEPHARMACYSTEP1",
	ERP_MODULE_PHARMACIES_STEP_2: "ERPMODULEPHARMACYSTEP2",
	ERP_MODULE_PHARMACIES_STEP_3: "ERPMODULEPHARMACYSTEP3",
	ERP_MODULE_PHARMACIES_STEP_4: "ERPMODULEPHARMACYSTEP4",
	ERP_MODULE_PHARMACIES_STEP_5: "ERPMODULEPHARMACYSTEP5",
	ERP_MODULE_PHARMACIES_STEP_6: "ERPMODULEPHARMACYSTEP6",
	ERP_MODULE_PHARMACIES_STEP_7: "ERPMODULEPHARMACYSTEP7",

	ERP_MODULE_USERS_STEP_1: "ERPMODULEUSERSTEP1",
	ERP_MODULE_USERS_STEP_2: "ERPMODULEUSERSTEP2",
	ERP_MODULE_USERS_STEP_3: "ERPMODULEUSERSTEP3",
	ERP_MODULE_USERS_STEP_4: "ERPMODULEUSERSTEP4",
	ERP_MODULE_USERS_STEP_5: "ERPMODULEUSERSTEP5",
	ERP_MODULE_USERS_STEP_6: "ERPMODULEUSERSTEP6",
	ERP_MODULE_USERS_STEP_7: "ERPMODULEUSERSTEP7",

	ERP_MODULE_PHARMACY_ROUTE_ALL: "ALL",
	ERP_MODULE_PHARMACY_ROUTE_ASSIGNED: "ASSIGNED",
	ERP_MODULE_PHARMACY_ROUTE_UNASSIGNED: "UNASSIGNED",
	ERP_MODULE_PHARMACY_ROUTE_WITH_ORDERS: "WITHORDERS",

	ERP_MODULE_STATES_STEP_1: "ERPMODULESTATESTEP1",
	ERP_MODULE_STATES_STEP_2: "ERPMODULESTATESTEP2",
	ERP_MODULE_STATES_STEP_3: "ERPMODULESTATESTEP3",
	ERP_MODULE_STATES_STEP_4: "ERPMODULESTATESTEP4",

	ERP_MODULE_ERRORS_STEP_1: "ERPMODULEERRORSSTEP1",
	ERP_MODULE_ERRORS_STEP_2: "ERPMODULEERRORSSTEP2",
	ERP_MODULE_ERRORS_STEP_3: "ERPMODULEERRORSSTEP3",
	ERP_MODULE_ERRORS_STEP_4: "ERPMODULEERRORSSTEP4",

	SORT_ASC: "ASC",
	SORT_DESC: "DESC",

	PHARMACY_MODULE_ORDERS: "PHARMACYMODULEORDERS",
	PHARMACY_MODULE_PRODUCTS: "PHARMACYMODULEPRODUCTS",
	PHARMACY_MODULE_DASHBOARDS: "PHARMACYMODULEDASHBOARDS",
	PHARMACY_MODULE_USERS: "PHARMACYMODULEUSERS",

	PHARMACY_MODULE_ORDERS_STEP_1: "PHARMACYMODULEORDERSTEP1",
	PHARMACY_MODULE_ORDERS_STEP_2: "PHARMACYMODULEORDERSTEP2",
	PHARMACY_MODULE_ORDERS_STEP_3: "PHARMACYMODULEORDERSTEP3",
	PHARMACY_MODULE_ORDERS_STEP_4: "PHARMACYMODULEORDERSTEP4",

	PRODUCTS_ACTIVE: "ACTIVE",
	PRODUCTS_INACTIVE: "INACTIVE",

	PHARMACY_MODULE_PRODUCTS_STEP_1: "PHARMACYMODULEPRODUCTSTEP1",
	PHARMACY_MODULE_PRODUCTS_STEP_2: "PHARMACYMODULEPRODUCTSTEP2",
	PHARMACY_MODULE_PRODUCTS_STEP_3: "PHARMACYMODULEPRODUCTSTEP3",
	PHARMACY_MODULE_PRODUCTS_STEP_4: "PHARMACYMODULEPRODUCTSTEP4",

	PRODUCTS_FOR_FEATUREDS_SALES: "SALES",
	PRODUCTS_FOR_FEATUREDS_UNITS: "UNITS",
	PRODUCTS_FOR_FEATUREDS_ORDERS: "ORDERS",

	MODULE_ONE_TRANSFER: "MODULEONETRANSFER",
	MODULE_ERP: "MODULEERP",
	MODULE_MARKETPLACE: "MODULEMARKETPLACE",

	MODULE_ONE_TRANSFER_BUSINESS: "MODULEONETRANSFERBUSINESS",
	MODULE_ERP_GENERAL_PDV: "MODULEERPGENERALPDV",
	MODULE_ERP_MOBILE: "MODULEERPMOBILE",
	MODULE_MARKETPLACE_PRODUCTS: "MODULEMARKETPLACEPRODUCTS",
	MODULE_MARKETPLACE_PUBLICITY: "MODULEMARKETPLACEPUBLICITY",
	MODULE_ERP_IA: "MODULEERPIA",

	USER_ROL_OT_ADMIN: "MASTERADMINOT",
	USER_ROL_OT_ACCOUNT: "CLIENTADMINOT",
	USER_ROL_OT_ANALIST: "ANALIST",
	USER_ROL_OT_SELLER: "SELLEROT",
	USER_ROL_OT_SELLER_MOBILE: "SELLERMOBILEOT",
	USER_ROL_OT_SUPPORT: "SUPPORTOT",
	USER_ROL_OT_TELEPHONIST: "TELEPHONISTOT",

	MODULE_GENERAL_POS_DETAILS: "MODULEGENERALPOSDETAILS",

	CONFIG_WEB: "CONFIGWEB",
	CONFIG_MOBILE: "CONFIGMOBILE",

	STATE_VALIDATED: "VALIDATED",
	STATE_NOT_VALIDATED: "NOTVALIDATED",

	REQUEST_BANNERS_ACTIVE: "ACTIVE",
	REQUEST_BANNERS_PENDING: "PENDING",
	REQUEST_BANNERS_DISABLED: "DISABLED",

	VIEW_LIST: "LIST",
	VIEW_GRID: "GRID",

	URL_IMPORT_ICON:
		"https://stotprodeus001.blob.core.windows.net/images/icons/IconImportFile.jpg",
	URL_SHEET_ICON:
		"https://stotprodeus001.blob.core.windows.net/images/icons/IconSheet.jpg",

	ROUTE_LIST_ASSIGNED: "ASIGNADOS",
	ROUTE_LIST_UNASSIGNED: "SINASIGNAR",

	ROUTE_ASSING: "ASSING",
	ROUTE_VALIDATION: "VALIDATION",

	AGENT_CONVERSATION: {
		user: { label: "Usuario", color: "blue" },
		assistant: { label: "Agente", color: "purple" },
		system: { label: "Sistema", color: "volcano" },
		Idle: { label: "Inactiva", color: "blue" },
		AddingItems: { label: "Agregando productos", color: "cyan" },
		SelectingDistributor: { label: "Eligiendo drogueria", color: "cyan" },
		ConfirmingDistributor: { label: "Confirmando drogueria", color: "cyan" },
		ConfirmingCode: { label: "Codigo cliente", color: "cyan" },
		ReviewingCart: { label: "Revisando carro", color: "cyan" },
		AwaitingFinalConfirmation: {
			label: "Esperando confirmacion final",
			color: "lime",
		},
		Done: { label: "Terminada", color: "green" },
	},

	AGENT_SELLER_PROFILES: [
		{ value: "consultivo", label: "Orientado a sugeridos" },
		{ value: "ofertas_volumen", label: "Orientado a ofertas" },
		{ value: "upselling_suave", label: "Orientado a ventas suave" },
		{ value: "cross_selling", label: "Orientado a ventas cruzadas" },
	],

	AGENT_SELLER_TYPE_OF_COMMUNICATION: [
		{ value: "amable", label: "Amable y cordial" },
		{ value: "conciso_directo", label: "Conciso y directo" },
		{ value: "didactico", label: "Didáctico" },
		{ value: "formal", label: "Formal y corporativo" },
		{ value: "informal_cercano", label: "Informal y cercano" },
		{ value: "entusiasta", label: "Entusiasta" },
		{ value: "analitico", label: "Analítico" },
	],

	AGENT_ORDERS: {
		pending: { label: "Pendiente", color: "cyan" },
		active: { label: "Activa", color: "green" },
		canceled: { label: "Cancelada", color: "volcano" },
		sended: { label: "Enviada", color: "green" },
	},

	WEBHOOK_MODE_OPTIONS: [
		{ value: "Prod", label: "Producción (normal)" },
		{ value: "DevProxy", label: "DevProxy (rutear a dev/local)" },
		{ value: "OutOfService", label: "Fuera de servicio (OOS)" },
	],
};
